import React from 'react'
import { Box } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { brandColors } from 'transfix-ui'

interface IStepButtonsProps {
  children: React.ReactNode
}

const StepButtonContainer = ({ children }: IStepButtonsProps) => {
  const { isMobile } = useBreakpointContext()

  return (
    <Box
      width='100%'
      display='flex'
      justifyContent='right'
      flexDirection={isMobile ? 'column-reverse' : 'row'}
      gap='10px'
      borderTop={`1px solid ${brandColors.coolGray2}`}
      marginTop='20px'
      paddingTop='20px'>
      {children}
    </Box>
  )
}

export default StepButtonContainer
